export const portfolioItems = [
  {
    title: "Movilib",
    categories: "ReactJs",
    image: "../assets/img/portfolio/movilib-1.png",
    link: "/movilib",
  },
  {
    title: "Imo241",
    categories: "WordPress",
    image: "../assets/img/portfolio/imo241.png",
    link: "/imo241",
  },
  {
    title: "CyberSynopsis",
    categories: "WordPress",
    image: "../assets/img/portfolio/cybersynopsis.png",
    link: "/cybersynopsis",
  },
  {
    title: "Fidelle Tech Support",
    categories: "JavaScript",
    image: "../assets/img/portfolio/fts-1.png",
    link: "/fidelle-tech",
  },
  {
    title: "Cinch Finance",
    categories: "WordPress",
    image: "../assets/img/portfolio/cinch-1.png",
    link: "/cinch",
  },
  {
    title: "Lia-sa",
    categories: "JavaScript",
    image: "../assets/img/portfolio/lia-1.png",
    link: "/lia-sa",
  },
  {
    title: "My-Bank",
    categories: "JavaScript ReactJs NextJs",
    image: "../assets/img/portfolio/my-bank.png",
    link: "/my-bank",
  },
  {
    title: "PlayStation",
    categories: "JavaScript ReactJs NextJs",
    image: "../assets/img/portfolio/playstation.png",
    link: "/playstation",
  },
  {
    title: "ASEAT",
    categories: "WordPress",
    image: "../assets/img/portfolio/aseat.png",
    link: "/aseat",
  },
  {
    title: "ETSAkombi",
    categories: "WordPress",
    image: "../assets/img/portfolio/etsakombi.png",
    link: "/etsakombi",
  },
  {
    title: "Foodie Gabon",
    categories: "SMM",
    image: "../assets/img/portfolio/Foodie_stats.png",
    link: "/Foodie",
  },
  {
    title: "Frango Grill Gabon",
    categories: "SMM",
    image: "../assets/img/portfolio/fango_stats.png",
    link: "/Frango",
  },
];

export const filterCategories = [
  { name: "All", filter: "*" },
  { name: "React.js", filter: ".ReactJs" },
  { name: "JavaScript", filter: ".JavaScript" },
  { name: "Next.js", filter: ".NextJs" },
  { name: "JQuery", filter: ".JQuery" },
  { name: "PHP", filter: ".PHP" },
  { name: "WordPress", filter: ".WordPress" },
  { name: "SMM", filter: ".SMM" },
];
